// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e57e5940","498":"0348a5b7","703":"9dee83b8"}[chunkId] + ".chunk.js";
};